<template>
  <div class="entry">
    <div class="main clearfix">
      <SiteSide />
      <div class="right">
        <SiteHeader />
        <div class="content">
          <router-view />
        </div>
      </div>
    </div>

    <PublicNotify v-if="userInfo.identity !== 0 && !['signIn', 'signUp', 'findPass'].includes(routeName)" />
    <PublicAlert/>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader/SiteHeader.vue'
import SiteSide from '@/components/SiteSide/SiteSide.vue'
import PublicNotify from '@/components/PublicNotify'
import PublicAlert from '@/components/PublicAlert'
import { mapState } from 'vuex'
export default {
  name: 'home',
  data () {
    return {
      routeName: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('getUserInfo')
    })
  },
  created () {
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      this.$store.commit('SET_IS_SHOW_NAV', false)
      this.$store.commit('SET_DEVICE', 'mobile')
    } else {
      this.$store.commit('SET_DEVICE', 'pc')
    }
    this.setRouteName()
  },
  watch: {
    $route () {
      this.setRouteName()
    }
  },
  methods: {
    setRouteName () {
      this.routeName = this.$route.name
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  components: {
    SiteHeader,
    SiteSide,
    PublicNotify,
    PublicAlert
  }
}
</script>
<style lang="scss">
@media only screen and (min-width: 756px) {
  .entry {
    min-height: 100vh;

    >.main {
      width: 100%;
      position: relative;
      padding-left: 260px;

      >.right {
        width: 100%;
        position: relative;
        min-height: 100vh;

        >.content {
          padding: 0 38px;
        }
      }
    }
  }
}

@media only screen and (max-width: 755px) {
  .entry {
    min-height: 100vh;

    >.main {
      width: 100%;
      position: relative;

      >.right {
        width: 100%;
        position: relative;
        min-height: 100vh;

        >.content {
          padding: 0 38px;
        }
      }
    }
  }
}
</style>
